 
 
const env = {
  "cognitoinfo": {
    "userpoolid": "us-east-1_gcHr01CMi",
    "clientid": "2pg7hcgmi8afrv709uiu70o8t3"
  },
  "mirthendpoints": {
    "globalsettings": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/globalsettings",
    "getcampaignlist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getcampaignslist",
    "getunusedcampaigns": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getunusedcampaigns",
    "getcampaignswithoutnotification": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getcampaignswithoutnotification",
    "getskillgroups": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getskillgrouplistahs",
    "clonecampaign": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/clonecampaign",
    "createcampaignucce": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createcampaignuccev2",
    "createcampaignuccx": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createcampaignuccxahs",
    "createcampaignemailsms": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createcampaignemailsmsv2",
    "getsmsdefaults": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/smsdefaults",
    "updatecampaignbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatecampaignbyid",
    "deletecampaignbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/delcampaignbyid",
    "getcampaignbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getcampaignbyid",
    "clonenotificationlist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/clonenotificationlist",
    "notificationlist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/notificationlist",
    "hl7datafields": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/hl7data",
    "updatenotificationlist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatenotificationlist",
    "getnotificationlistbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getnotificationlist",
    "createdatasourcerules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createdatasourcerules",
    "updatedatasourcerules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatedatasourcerules",
    "createdataidentifier": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createdataidentifier",
    "updatedataidentifier": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatedataidentifier",
    "getmsgrule": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getmsgrule",
    "createmsgrule": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createmsgrule",
    "updatemsgrule": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatemsgrule",
    "getdatasourcerules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getdatasourcerules",
    "getdataidentifier": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getdataidentifier",
    "practicetimer": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/practicetimer",
    "delpracticetimerbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/delpracticetimerbyid",
    "timerpreset": "https://pacdev.patient-notify.agenta-cloud.com/agenta/ssi/timerpresets",
    "gettimerpresetsbylist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/gettimerpresetsbylist",
    "gettimerpresetsbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/gettimerpresetsbyid",
    "updatetimerpresets": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatetimerpresets",
    "deltimerpresetsbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/deltimerpresetsbyid",
    "schedulevariablelist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/schedulevariablelist",
    "getvariablesmedia": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getvariablesmedia",
    "mediatemplate": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediatemplate",
    "updatemediatemplatemsgbyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatemediatemplatemsgbyid",
    "getmediatemplatesbyidtype": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getmediatemplatebytypeandid",
    "getmediatemplatebyidtypecode": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getmediatemplatebyidtypecode",
    "getmediatemplatebyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getmediatemplate",
    "createusedmedialist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createtemplatelist",
    "updateusedmedialist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatetemplatelist",
    "getusedmedialist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/gettemplatelist",
    "getalldataidentifiers": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/get_dataidentifier_data",
    "ciscotmpfileUpload": "https://{ip-address}/adminapi/prompt/uploadFile",
    "ciscoAdminPrompt": "https://{ip-address}/adminapi/prompt",
    "wavBaseURL": "https://sso-media.s3-us-west-2.amazonaws.com/Wav/",
    "quicksightURL": "https://embedurl.rndspinsci.com/embeddedurl",
    "searchdpvItems": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/searchdpvcontrols",
    "getdpvcontrols": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getdpvcontrols",
    "updatedpvcontrols": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatedpvcontrols",
    "createdpvcontrols": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createdpvcontrols",
    "getcustomerdata": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getcustomerdata",
    "updatecustomerdata": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatecustomerdata",
    "addcustomerdata": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/addcustomerdata",
    "getfhsmstemplatestypes": "https://pacdev.patient-engage.agenta-cloud.com/agenta/sso/getsmsmessagetemplatefh",
    "login": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/checklogincredentials",
    "register": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/registeruser",
    "getuserinfo": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/userinfo",
    "resendverification": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/resendverification",
    "verifyToken": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/verificationtoken",
    "getusers": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getuserlist",
    "updateuserrole": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updateuserrole",
    "testsms": "https://8aim7f6o9k.execute-api.us-west-2.amazonaws.com/default/Froedtert_Staging?channel=sms",
    "getvoicemediatemplates": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getvoicemessagetemplatesfh",
    "updatevoicemdiaitembyid": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getvoicemediamessagefh",
    "createvoicemediaitem": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createvoicemediamessagefh",
    "updateexclusionlisturl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/exclusionlist",
    "getsftpdetails": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getsftpdetails",
    "createsftpdetails": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createsftpdetails",
    "updatesftpdetails": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatesftpdetails",
    "fileconfiguration": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/fileconfiguration",
    "setadvancedrules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/setadvancedrules",
    "getadvancedrules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/getadvancedrules",
    "checksftpconnection": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/checksftpconnection",
    "channeldomains": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/channeldomains",
    "campaigntypes": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/campaigntypes",
    "voicedomains": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/voicedomains",
    "smsdomains": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/smsdomains",
    "timerpresets": "https://pacdev.patient-notify.agenta-cloud.com/agenta/ssi/timerpresets",
    "campaigns": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/campaigns",
    "notifications": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/notifications",
    "duplicaterules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/duplicaterules",
    "advancedrules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/advancedrules",
    "participants": "https://pacdev.patient-notify.agenta-cloud.com/agenta/ssi/participants",
    "participantsconfig": "https://pacdev.patient-notify.agenta-cloud.com/agenta/ssi/participantsconfig",
    "engagemediacontent": "https://pacdev.patient-notify.agenta-cloud.com/agenta/ssi/mediacontent",
    "engageLanguages": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/medialanguages",
    "createbulkparticipants": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/createbulkparticipants",
    "removebulkparticipants": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/removebulkparticipants",
    "excludeinclude": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/excludeinclude",
    "workflowrulesdomain": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/workflowrulesdomain",
    "workflowrules": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/workflowrules",
    "campaignworkflow": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/campaignworkflow",
    "mediatemplates": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediatemplates",
    "translationmap": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/translationmap",
    "medialanguages": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/medialanguages",
    "mediamessages": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediamessage",
    "mediamessagesmvp": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediamessagesmvp",
    "mediatags": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediatags",
    "availablecampaigns": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/availablecampaigns",
    "voicemappings": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/voicemappings",
    "campaignstatus": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/campaignstatus",
    "mediachannels": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediachannels",
    "baseURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/",
    "curbsideDepartments": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/departments",
    "curbsideuserPresence": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/patientpresence",
    "curbsideuserDepartment": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/patientdepartment",
    "curbotserverUrl": "https://pacdev.patient-notify.agenta-cloud.com:8871",
    "storedprocedureURL": "https://{ip-address}/agenta/sso/patientdepartment",
    "queueURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/queue-report",
    "dispositionsURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/disposition-report",
    "dispositionURL": "https://pacdev.patient-notify.agenta-cloud.com/sso/patientdepartment",
    "getdailyCallsReportUrl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/fetchdailyreport",
    "gethourlyCallsReportUrl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/generatereporthourly",
    "getbatchprocessSettingUrl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/updatenotificationbatchsetting",
    "getSelectBatchFieldCallUrl": " https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/fetchdispositioncode",
    "gethl7variablename": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/gethl7variablename",
    "dispositionWrite": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/disposition",
    "getBatchDispositionDataURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/fetchbatchsettingdata",
    "getBatchReportUrl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/dispositonsearch",
    "getQickSightReportUrl": "https://o1z1onmp69.execute-api.us-west-2.amazonaws.com/QuickSight-PACDEV/quicksight-pacdev",
    "historicalqueueURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/queue-report-historical",
    "queuecountURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/tab-queue-report",
    "csvintake": "https://pacdev.patient-notify.agenta-cloud.com/agenta/fileupload/diallist",
    "filefetcher": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/file-fetcher",
    "donotcallURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/tab-dnc-file",
    "getdonotcallListURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/tab-advanced-rules",
    "tabwavemapURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/wave-info",
    "s3URL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/fileupload/audio/",
    "hl7RestInterface": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/hl7-rest-interface",
    "restcsvurl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/fileupload/rest-csv",
    "csvcolmapping": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/csv-col-mapping",
    "translationmapvalues": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/translationmapvalues",
    "csvDispositionReportUrl": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/csv-disposition-report",
    "csvProcessURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/csv-process-report",
    "dequeueSettings": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/dequeue-settings",
    "queueFlushedCountURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/queue-flash-count-report",
    "queueFlushedDetailURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/queue-flash-detail-report",
    "statisticsReportURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/statistics-report",
    "exceptionReportURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/error-log-report",
    "waveFileDownloadURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/filereceiver/audio/",
    "systemReportURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/system-report",
    "cognitoLambdaBaseURL": "https://m15ve18qg0.execute-api.us-east-1.amazonaws.com/Dev",
    "callSummaryURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/fetch-callstatus-report ",
    "causeCodeCategoryURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/causecodecategory",
    "failedreasondefURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/failedreasondef",
    "dcregionlist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/dcregionlist",
    "queueTriggerURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/queue-trigger",
    "getFive9CampaignList": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/get-campaign-list-five9",
    "getFive9DialList": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/get-dial-list-five9",
    "emaildomains": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/emaildomains",
    "campaignsv2": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/campaignsv2",
    "notificationsv2": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/notificationsv2",
    "mediatemplatesv2": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/mediatemplatesv2",
    "timerpresetsv2": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/timerpresetsv2",
    "ciscocampaignslist": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/ciscocampaigns",
    "campaignDetails": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/campaignnotmedia",
    "getPEQickSightReportUrl": "https://h28h55cubk.execute-api.us-west-2.amazonaws.com/QuickSight-PACDEV-PE/quicksight-pacdev-pe",
    "messageTemplates": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/message-templates",
    "ftpURL":"https://{ip-address}/POST-A",
    "mediaListURL": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/wave-info",
    "getAllDispositions": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/get-all-disposition-values",
    "updatecampaignDispositionCalCode": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/update-campaign-disposition-calcode",
    "queueGroups": "https://pacdev.patient-notify.agenta-cloud.com/agenta/sso/queue-groups"
    //"mediaListURL": "https://{ip-address}/epic/v1/mediafileupload",
  },
  "features": [
    {
      "title": "Patient Notify",
      "visible": true,
      "children": [
        {
          "title": "Settings",
          "visible": true
        },
        {
          "title": "Config",
          "visible": true
        },
        {
          "title": "Rules",
          "visible": true
        },
        {
          "title": "Media Management",
          "visible": true
        },
        {
          "title": "Command Center",
          "visible": true
        },
        {
          "title": "Do Not Call List",
          "visible": true
        }
      ]
    },
    {
      "title": "Patient Engage",
      "visible": true,
      "children": [
        {
          "title": "Settings",
          "visible": false
        },
        {
          "title": "Config",
          "visible": true
        },
        {
          "title": "Media",
          "visible": true
        },
        {
          "title": "Command Center",
          "visible": false
        }
      ]
    },
    {
      "title": "Patient Assist",
      "visible": false,
      "children": [
        {
          "title": "Settings",
          "visible": true
        },
        {
          "title": "Config",
          "visible": true
        },
        {
          "title": "Command Center",
          "visible": true
        }
      ]
    },
    {
      "title": "Setup",
      "visible": true,
      "children": [
        {
          "title": "Voice Media Explorer",
          "visible": true
        },
        {
          "title": "Timer-presets",
          "visible": true
        },
        {
          "title": "Entity Configuration",
          "visible": true
        },
        {
          "title": "User Management",
          "visible": true
        }
      ]
    },
    {
      "title": "Reports",
      "visible": true,
      "children": [
        {
          "title": "PN Reports",
          "visible": true
        },
        {
          "title": "Patient Assist",
          "visible": false
        },
        {
          "title": "PE Reports",
          "visible": false
        }
      ]
    },
    {
      "title": "Simulator",
      "visible": true
    },
    {
      "title": "Version",
      "visible": true
    },
    {
      "title": "Message Template",
      "visible": false
    }
  ],
  "lockoutpolicy": {
    duration: 30,
  }
}
 
window.environment = env;
